<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import ClassDetailsTab from './ClassDetailsTab'
export default {
  name: 'Details',
  components: {
    ClassDetailsTab
  },
  mounted () {
  },
  data () {
    return {
      title: this.$route.meta.title,
      module: this.$route.meta.module
    }
  },
  computed: {
    ...mapState({
      open: state => state.detailsModal
    }),
    ...mapState('users', {
      tabs: state => state.tabs
    })
  },
  methods: {
    test (tab) {
    },
    ...mapActions('users', [
      'submitRoleForm'
    ]),
    ...mapMutations('users', [
      'updateDetailsForm'
    ]),
    ...mapMutations([
      'closeDetails'
    ])
  }
}

</script>

<template>
  <div>
    <q-tabs
      no-pane-border
      align="center"
      class="fit"
    >
      <!-- Tabs - notice slot="title" -->
      <q-tab default slot="title" name="details" label="Details"></q-tab>
      <q-tab slot="title" name="role" label="Sessions"></q-tab>
      <q-tab slot="title" name="documents" label="Documents"></q-tab>
      <q-tab slot="title" name="notes" label="Notes"></q-tab>

      <!-- Targets -->
      <q-tab-pane name="details" class="fit" >
        <class-details-tab/>
      </q-tab-pane>
      <q-tab-pane name="sessions" class="fit">
      </q-tab-pane>
      <q-tab-pane name="documents" class="fit">
      </q-tab-pane>
      <q-tab-pane name="notes" class="fit">
      </q-tab-pane>
    </q-tabs>
  </div>
</template>

<style lang="css">
  .q-tabs-panes {
    display: flex
  }
</style>
